import { isEmail } from 'framework/utils';
import { InterruptionDto, InterruptionEmployeeResponseStatus, InterruptionType } from '../../types';
import { isEmergencyInterruptionExpired } from './emergencyInterruptionMappers';
import { isEmergencyInterruptionForCurrentUser, isListInterruptionForCurrentUser } from './socketInterruptionMappers';

export const hasRequiredEmails = (payload: InterruptionDto): boolean => {
  return isEmail(payload.context?.creatorEmail ?? '') && isEmail(payload.context?.recipientEmail ?? '');
};

export const isIncomingInterruptionTracked = (
  interruptionId: string,
  emergencyInterruptions: InterruptionDto[],
  listInterruptions: InterruptionDto[],
): boolean => {
  return (
    emergencyInterruptions.some(item => item.id === interruptionId) ||
    listInterruptions.some(item => item.id === interruptionId)
  );
};

export const shouldAddIncomingInterruptionToList = (interruption: InterruptionDto, currentUserId: string): boolean => {
  return hasRequiredEmails(interruption) && isListInterruptionForCurrentUser(interruption, currentUserId);
};

export const shouldAddEmergencyInterruption = (interruption: InterruptionDto, currentUserId: string): boolean => {
  return (
    hasRequiredEmails(interruption) &&
    isEmergencyInterruptionForCurrentUser(interruption, currentUserId) &&
    !isEmergencyInterruptionExpired(interruption)
  );
};

const isInitialListInterruptionType = (item: InterruptionDto): boolean => item.type === InterruptionType.TaskStatusPing;

export const getInitialListInterruptions = (
  interruptions: InterruptionDto[],
  emergencyInterruptions: InterruptionDto[],
  listInterruptions: InterruptionDto[],
  currentUserId: string,
): InterruptionDto[] =>
  interruptions.filter(
    item =>
      isInitialListInterruptionType(item) &&
      item.employeeResponseStatus === InterruptionEmployeeResponseStatus.New &&
      !isIncomingInterruptionTracked(item.id, emergencyInterruptions, listInterruptions) &&
      shouldAddIncomingInterruptionToList(item, currentUserId),
  );

export const getInitialEmergencyInterruptions = (
  interruptions: InterruptionDto[],
  emergencyInterruptions: InterruptionDto[],
  listInterruptions: InterruptionDto[],
  currentUserId: string,
): InterruptionDto[] =>
  interruptions.filter(
    item =>
      !isIncomingInterruptionTracked(item.id, emergencyInterruptions, listInterruptions) &&
      shouldAddEmergencyInterruption(item, currentUserId),
  );
